module.exports = __webpack_public_path__ + "static/media/Gemeente Utrecht Logo.1b26a66d.jpg";